import React, { useLayoutEffect } from 'react';
import { View } from 'react-native';
import { WebView } from 'react-native-webview';
import HeaderAccentTitle from '../../shared/HeaderAccentTitle';
import { CommonStyles } from '../../../styles';

const TrackTrainWebModal = ({ navigation }) => {
  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <HeaderAccentTitle title="Amtrack Track Train" subtitle="amtrack.com" />,
    });
  }, [navigation]);

  return (
    <View style={CommonStyles.flex1}>
      <WebView
        startInLoadingState
        source={{ uri: `https://www.amtrak.com/track-your-train.html` }}
      />
    </View>
  );
};

export default TrackTrainWebModal;
